import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/cards/in-parking/multi-delete/';

interface DTO {
    parkingId: string;
    cardsId: string[];
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as DELETE_MULTIPLE_CARDS_RESOURCE, useMutationHook as useDeleteMultipleCards };
export type { DTO as DeleteMultipleCardsDTO };
